import { render, staticRenderFns } from "./OvbApp.vue?vue&type=template&id=36324ca5&scoped=true&"
import script from "./OvbApp.vue?vue&type=script&lang=js&"
export * from "./OvbApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36324ca5",
  null
  
)

export default component.exports